import type { Series } from '../api'

export function SeriesDot({ series, size = 8 }: { series: Series; size?: number }) {
  return (
    <span
      className="series-dot"
      data-series={series}
      style={{ width: size, height: size }}
      aria-hidden="true"
    />
  )
}
